import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import {
  DashboardSummaryQueryParams,
  DashboardSummaryResponse,
  EMPTY_DASHBOARD_SUMMARY,
  WorkflowListResponse,
  WorkflowOption,
} from '../interfaces';

export interface DashboardConfig {
  apiUrl?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private readonly http = inject(HttpClient);
  private config: DashboardConfig | null = null;

  configure(config: DashboardConfig): void {
    this.config = config;
  }

  getDashboardSummary(params?: DashboardSummaryQueryParams): Observable<DashboardSummaryResponse> {
    const apiUrl = this.getApiUrl();
    let httpParams = new HttpParams();

    if (params?.range) {
      httpParams = httpParams.set('range', params.range);
    }

    if (typeof params?.workflow_id === 'number' && !Number.isNaN(params.workflow_id)) {
      httpParams = httpParams.set('workflow_id', params.workflow_id.toString());
    }

    if (params?.status) {
      httpParams = httpParams.set('status', params.status);
    }

    return this.http
      .get<DashboardSummaryResponse>(`${apiUrl}/api/dashboard/summary/`, {
        params: httpParams,
      })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          console.error('Error obteniendo resumen del dashboard:', error);
          return of(EMPTY_DASHBOARD_SUMMARY);
        }),
      );
  }

  getWorkflows(): Observable<WorkflowOption[]> {
    const apiUrl = this.getApiUrl();
    const params = new HttpParams().set('limit', '200').set('page', '1');

    return this.http.get<WorkflowListResponse>(`${apiUrl}/api/workflows/`, { params }).pipe(
      map((res) => res.data),
      catchError(() => of([])),
    );
  }

  private getApiUrl(): string {
    if (!this.config?.apiUrl) {
      throw new Error('DashboardService no está configurado. Llama a configure() primero.');
    }

    return this.config.apiUrl;
  }
}
